"use strict";
/**
 * Lenses for JSON data.
 *
 * @module
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./../utils");

var base_1 = require("./base"); // @TODO can we optimize this regexp?


var PROP_EXPR_RE = new RegExp(['^', 'function', '\\(', '[^), ]+', '\\)', '\\{', '("use strict";)?', 'return\\s', '[^\\.]+\\.(\\S+?);?', '\\}', '$'].join('\\s*'));
var WALLABY_PROP_EXPR_RE = new RegExp(['^', 'function', '\\(', '[^), ]+', '\\)', '\\{', '("use strict";)?', '(\\$_\\$wf\\(\\d+\\);)?', 'return\\s', '(\\$_\\$w\\(\\d+, \\d+\\),\\s)?', '[^\\.]+\\.(\\S+?);?', '\\}', '$'].join('\\s*'));

function parsePropertyPath(getterSource) {
  var exprRegexp = process.env.NODE_ENV === 'wallaby' ? WALLABY_PROP_EXPR_RE : PROP_EXPR_RE;
  var exprRegexpGroup = process.env.NODE_ENV === 'wallaby' ? 4 : 2;
  var parse = getterSource.match(exprRegexp);

  if (parse && parse[exprRegexpGroup]) {
    return parse[exprRegexpGroup].split('.');
  } else {
    throw new TypeError("Expected a property expression, got \"" + getterSource + "\".\n\n      A property expression should be a referentially transparent (no side-effects),\n      single-expression \"getter\" function.\n\n      Correct example: \"function (x) { return x.some }\" or \"x => x.some\".\n      Incorrect example: \"function (x) { var y = x.some; return y }\" or \"({some}) => some\"");
  }
}

exports.parsePropertyPath = parsePropertyPath;
/**
 * Extract a list of property names from a {@link PropExpr}
 *
 * @param target The target property expressions
 * @example
 * type Second = { two: string }
 * type First = { one: Second }
 * // returns ['one', 'two']
 * extractPropertyNames((x: First) => x.one.two)
 * @returns A list of nested property names
 * @throws Will throw if the target lens expression is of a not valid form
 */

function extractPropertyPath(target) {
  return parsePropertyPath(target.toString());
}

exports.extractPropertyPath = extractPropertyPath;

function keyImpl(k) {
  return k === undefined // type-safe key
  ? function (k) {
    return base_1.Lens.create(function (s) {
      return s[k];
    }, function (v, s) {
      return utils_1.setKey(k, v, s);
    });
  } // untyped key
  : base_1.Lens.create(function (s) {
    return s[k];
  }, function (v, s) {
    return utils_1.setKey(k, v, s);
  });
}

exports.keyImpl = keyImpl;
var propExprDeprecatedWarnings = 0;

function warnPropExprDeprecated(path) {
  // don't warn more than a few times
  if (propExprDeprecatedWarnings < 10) {
    propExprDeprecatedWarnings++;
    var propExpr = "x." + path.join('.');
    var keys = "'" + path.join("', '") + "'";
    utils_1.warning("The property expression overload of Atom.lens and Lens.prop are deprecated and " + "will be removed in next versions of Focal. Please use the key name overload for " + "Atom.lens and Lens.key instead. " + ("You can convert your code by changing the calls:\n  a.lens(x => " + propExpr + ") to a.lens(" + keys + "),\n  Lens.prop((x: T) => " + propExpr + ") to Lens.key<T>()(" + keys + ")."));
  }
}

function propImpl(getter) {
  var path = extractPropertyPath(getter);
  if (utils_1.DEV_ENV) warnPropExprDeprecated(path); // @TODO can we optimize this?

  return base_1.Lens.compose.apply(base_1.Lens, path.map(keyImpl()));
}

exports.propImpl = propImpl;

function indexImpl(i) {
  if (i < 0) throw new TypeError(i + " is not a valid array index, expected >= 0");
  return base_1.Prism.create(function (xs) {
    return xs[i];
  }, function (v, xs) {
    if (xs.length <= i) {
      return xs.concat(Array(i - xs.length), [v]);
    } else if (utils_1.structEq(v, xs[i])) {
      return xs;
    } else {
      return xs.slice(0, i).concat([v], xs.slice(i + 1));
    }
  });
}

exports.indexImpl = indexImpl;

function withDefaultImpl(defaultValue) {
  // @TODO is this cast safe?
  return base_1.Lens.replace(undefined, defaultValue);
}

exports.withDefaultImpl = withDefaultImpl;

function choose(getLens) {
  return base_1.Lens.create(function (s) {
    return getLens(s).get(s);
  }, function (v, s) {
    return getLens(s).set(v, s);
  });
}

function replaceImpl(originalValue, newValue) {
  return base_1.Lens.create(function (x) {
    return utils_1.structEq(x, originalValue) ? newValue : x;
  }, utils_1.conservatively(function (y) {
    return utils_1.structEq(y, newValue) ? originalValue : y;
  }));
}

exports.replaceImpl = replaceImpl;

function findImpl(predicate) {
  return choose(function (xs) {
    var i = utils_1.findIndex(xs, predicate);
    return i < 0 ? base_1.Lens.nothing() : base_1.Lens.index(i);
  });
}

exports.findImpl = findImpl;
base_1.Lens.key = keyImpl;
base_1.Lens.prop = propImpl;
base_1.Lens.index = indexImpl;
base_1.Lens.withDefault = withDefaultImpl;
base_1.Lens.replace = replaceImpl;
base_1.Lens.find = findImpl;